import type { MetaInfo } from 'vue-meta';
import { buildProductJsonLd, ProductJsonLdSource } from '~/helpers/buildProductJsonLd';
import { getMetaInfo } from '~/helpers/getMetaInfo';

type ProductMetaInfoOptions = {
  url?: string | null;
  isNoIndex?: boolean;
  includeJsonLd?: boolean;
};

export const getProductMetaInfo = (
  product?: ProductJsonLdSource | null,
  { url, isNoIndex = false, includeJsonLd = true }: ProductMetaInfoOptions = {},
): MetaInfo => {
  const seoTags = getMetaInfo(product, isNoIndex);
  const jsonLd = includeJsonLd ? buildProductJsonLd(product, { url }) : null;

  if (!jsonLd) {
    return seoTags;
  }

  return {
    ...seoTags,
    script: [
      {
        hid: 'ldjson-product',
        type: 'application/ld+json',
        json: jsonLd,
      },
    ],
  };
};
